import AppPagarComissaoDialog from "./dialogs/PagarComissaoDialog.vue";
import AppAdicionarComissaoDialog from "./dialogs/AdicionarComissaoDialog.vue";
import AppPagarComissaoCompletaDialog from "./dialogs/PagarComissaoCompletaDialog.vue";
import AppAdicionarPagamentoComissaoDialog from "./dialogs/AdicionarPagamentoComissaoDialog.vue";

import AppCriarDiretorioDialog from "../shared/dialogs/CriarDiretorioDialog.vue";
import AppSelecionarDiretorioDialog from "../shared/dialogs/SelecionarDiretorioDialog.vue";
import AppPerguntasFormularioDialog from "../shared/dialogs/PerguntasFormularioDialog.vue";
import AppUploadArquivoDialog from "../shared/dialogs/UploadArquivoDialog.vue";
import AppGravarObservacaoDialog from "../shared/dialogs/GravarObservacaoDialog.vue";

import { mapActions, mapState } from "vuex";
import { Money } from "v-money";
import { STATUS_PAGAMENTO, STATUS_CONTRATO } from "../util/constantes.js";
import Util from "../util/funcoes.js";

var BigDecimal = require("js-big-decimal");

export default {
  components: {
    AppPagarComissaoDialog,
    AppAdicionarComissaoDialog,
    AppPagarComissaoCompletaDialog,
    AppAdicionarPagamentoComissaoDialog,

    AppCriarDiretorioDialog,
    AppSelecionarDiretorioDialog,
    AppPerguntasFormularioDialog,
    AppUploadArquivoDialog,
    AppGravarObservacaoDialog,

    Money
  },
  data() {
    return {
      tabSelecionada: "detalhes",
      loadingUsuarios: false,
      loadingClientes: false,
      loadingImoveis: false,
      observacaoSelecionada: {},
      formularioSelecionado: {
        perguntasFormulario: []
      },
      comissaoSelecionada: {
        corretor: {
          nome: ""
        }
      },
      historicoComissaoSelecionada: {
        corretor: {
          nome: ""
        }
      },
      visibilidadeDialogAdicionarComissao: false,
      visibilidadeDialogPagarComissao: false,
      visibilidadeDialogPagarComissaoCompleta: false,
      visibilidadeDialogAdicionarPagamentoComissao: false,
      visibilidadeDialogCancelarPagamentoComissao: false,
      visibilidadeDialogRemoverPagamentoComissao: false,

      visibilidadeCriarDiretorioDialog: false,
      visibilidadeSelecionarDiretorioDialog: false,
      visibilidadePerguntasFormularioDialog: false,
      visibilidadeUploadArquivoDialog: false,
      visibilidadeGravarObservacaoDialog: false,

      comissaoImobiliaria: false,
      comissaoRestante: 0,
      percentualRestante: 0,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      },

      permissoes: {},

      defaultProps: {
        label: "nome",
        children: "formularios"
      },

      validacao: {
        dataVenda: [{ required: true, len: 10 }],
        imovel: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        comprador: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        atendente: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        valor: [{ type: "number", min: 1 }],
        comissao: [{ type: "number", min: 0.01, max: 100 }]
      }
    };
  },
  created() {
    this.pesquisar();

    this.usuarioLogado.permissoes.forEach(item => {
      if (item.modulo === "CONTRATOS_VENDA") {
        this.permissoes = item;
      }
    });
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado; }
    }),
    ...mapState("vendasStore", {
      venda(state) { return state.vendaSelecionada; },
      vendas(state) { return state.listaVendas; },
      vendaPesquisa(state) { return state.vendaPesquisa; },
      logs(state) { return state.logs; },
      formularios(state) { return state.formularios; },
      dadosPesquisaVenda() {
        return (
          this.vendaPesquisa.status != "" ||
          this.vendaPesquisa.dataVendaInicio != "" ||
          this.vendaPesquisa.dataVendaFim != "" ||
          this.vendaPesquisa.imovel.idNaImobiliaria != "" ||
          this.vendaPesquisa.cliente.nome != ""
        )
      }
    }),
    //PESQUISA
    status() {
      return STATUS_CONTRATO;
    },
    loading() {
      return this.$store.state.loading;
    },

    //CADASTRO
    usuariosDisponiveis() {
      return this.$store.state.vendasStore.usuariosDisponiveis;
    },
    clientesDisponiveis() {
      return this.$store.state.vendasStore.clientesDisponiveis;
    },
    imoveisDisponiveis() {
      return this.$store.state.vendasStore.imoveisDisponiveis;
    },
    vendaNova() {
      return this.venda.id == 0;
    },
    disableAlteracao() {
      return this.venda.id != 0;
    },
    statusPagamento() {
      return STATUS_PAGAMENTO;
    },
    util() {
      return Util;
    },
    exibirBotaoUploadArquivo() {
      return this.tabSelecionada == "arquivos";
    },
    exibirBotaoGravar() {
      return (
        (this.permissoes.cadastro &&
          this.tabSelecionada == "detalhes" &&
          this.venda.id === 0) ||
        (this.permissoes.alteracao &&
          this.venda.id !== 0 &&
          this.venda.status === "PENDENTE" &&
          this.tabSelecionada == "detalhes")
      );
    },
    exibirBotaoCriarDiretorio() {
      return (
        this.permissoes.geracaoFormularios &&
        this.tabSelecionada == "formularios"
      );
    },
    exibirBotaoGerarFormulario() {
      return (
        this.permissoes.geracaoFormularios &&
        this.tabSelecionada == "formularios" &&
        this.formularioSelecionado.nomeArquivo !== undefined &&
        this.formularioSelecionado.nomeArquivo !== null
      );
    },
    exibirBotaoRemover() {
      return (
        this.permissoes.remocao &&
        this.tabSelecionada == "detalhes" &&
        this.venda.status === "PENDENTE" &&
        this.venda.id !== 0
      );
    },
    exibirBotaoAprovar() {
      return (
        this.permissoes.alteracao &&
        this.tabSelecionada == "detalhes" &&
        this.venda.status === "PENDENTE" &&
        this.venda.id !== 0
      );
    },
    exibirBotaoDesaprovar() {
      return (
        this.permissoes.alteracao &&
        this.tabSelecionada == "detalhes" &&
        this.venda.status === "APROVADO" &&
        this.venda.id !== 0
      );
    },
    exibirBotaoAdicionarComissao() {
      if (this.tabSelecionada == "detalhes" && this.venda.id === 0) {
        return true;
      } else if (
        this.tabSelecionada == "detalhes" &&
        this.venda.status === "PENDENTE" &&
        this.venda.id !== 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    exibirBotaoGerarRecibosPagos() {
      return (
        this.comissaoSelecionada !== undefined &&
        this.comissaoSelecionada.id !== undefined &&
        this.comissaoSelecionada.id !== 0 &&
        !this.comissaoSelecionada.comissaoImobiliaria
      );
    },
    exibirBotaoPagarComissaoCompleta() {
      return (
        this.comissaoSelecionada !== undefined &&
        this.comissaoSelecionada.id !== undefined &&
        this.comissaoSelecionada.id !== 0 &&
        this.comissaoSelecionada.valorEmAberto !== 0
      );
    },
    exibirBotaoAdicionarPagamento() {
      return (
        this.comissaoSelecionada !== undefined &&
        this.comissaoSelecionada.id !== undefined &&
        this.comissaoSelecionada.id !== 0 &&
        this.comissaoSelecionada.valorEmAberto !== 0
      );
    },
    exibirBotaoGerarRecibo() {
      return (
        this.historicoComissaoSelecionada !== undefined &&
        this.historicoComissaoSelecionada.id !== 0 &&
        this.historicoComissaoSelecionada.status === "PAGO" &&
        this.historicoComissaoSelecionada.corretor.id !== 0
      );
    },
    exibirBotaoCancelarPagamento() {
      return (
        this.historicoComissaoSelecionada !== undefined &&
        this.historicoComissaoSelecionada.id !== 0 &&
        this.historicoComissaoSelecionada.status === "PAGO"
      );
    },
    exibirBotaoPagarPagamento() {
      return (
        this.historicoComissaoSelecionada !== undefined &&
        this.historicoComissaoSelecionada.id !== 0 &&
        this.historicoComissaoSelecionada.status === "EM_ABERTO"
      );
    },
    exibirColunaRemoverObservacao() {
      return this.permissoes.removerObservacoes;
    }
  },
  watch: {
    vendaNova(newValue) {
      if (newValue) {
        this.tabSelecionada = "detalhes";
      }
    },
    "venda.id": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.tabSelecionada = "detalhes";
        this.configurarDataGridComissoes();
      }
    }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("loginStore", [
      "validarAcesso"
    ]),
    ...mapActions("clientesStore", [
      "recuperarCliente"
    ]),
    ...mapActions("vendasStore", [
      "novaVenda",
      "listarVendas",
      "recuperarVenda",
      "gravarVenda",
      "removerVenda",
      "aprovarVenda",
      "desaprovarVenda",
      "listarUsuarios",
      "listarClientes",
      "listarImoveis",
      "recuperarLogs",
      "gerarFormularioVenda",
      "recuperarFormularios",
      "recuperarPerguntasFormulario",
      "removerDiretorioVenda",
      "gerarReciboComissaoPagos",
      "gerarReciboComissaoUnico",
      "gerarRelatorio",
      "cancelarPagamentoComissao",
      "removerPagamentoComissao",
      "removerArquivo",
      "removerObservacao"
    ]),
    //PESQUISA
    formatarLinha1Endereco(imovel) {
      return imovel.endereco + ", " + imovel.numeroEndereco;
    },
    formatarLinha2Endereco(imovel) {
      return imovel.condominio !== undefined &&
        imovel.condominio.nome !== undefined
        ? imovel.condominio.nome +
            " - " +
            imovel.bairro.nome +
            " - " +
            imovel.cidade.nome
        : imovel.bairro.nome + " - " + imovel.cidade.nome;
    },
    novo() {
      this.novaVenda();
    },
    pesquisar() {
      this.showLoading();
      this.listarVendas(this.vendaPesquisa)
      .then(() => {
        this.hideLoading();
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    recuperar(vendaSelecionada) {
      let payload = { id: vendaSelecionada.id };
      
      this.showLoading();
      this.recuperarVenda(payload)
      .then(() => {
        this.hideLoading();
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },

    //CADASTRO
    aprovar() {
      this.showLoading();
      this.aprovarVenda()
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    desaprovar() {
      this.showLoading();
      this.desaprovarVenda()
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    gravarHandler() {
      this.$refs["formVenda"].validate(valid => {
        if(valid && this.venda.comissoes.length > 0 && this.percentualRestante == 0) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.showLoading();
      this.gravarVenda()
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },
    remover() {
      let payload = { id: this.venda.id };
      
      this.showLoading();
      this.removerVenda(payload)
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },

    //FORMULARIOS
    selecionarFormulario(formularioSelecionado) {
      if(formularioSelecionado.nomeArquivo !== undefined && formularioSelecionado.nomeArquivo !== null) {
        this.formularioSelecionado = formularioSelecionado;
      } else {
        this.formularioSelecionado = { perguntasFormulario: [] };
      }
    },
    gerarFormulario() {
      if(this.formularioSelecionado != null) {
        let payload = { id: this.formularioSelecionado.id };

        this.showLoading();
        this.recuperarPerguntasFormulario(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.finalizarGeracaoFormulario(resultado);
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro.");
        });
      }
    },
    finalizarGeracaoFormulario(resultado) {
      this.formularioSelecionado = resultado.item;
      this.formularioSelecionado["venda"] = this.venda;
      
      if(this.formularioSelecionado.perguntasFormulario !== undefined) {
        this.exibirDialogPerguntasFormulario();  
      } else {
        this.showLoading();
        this.gerarFormularioVenda(this.formularioSelecionado)
        .then(() => {
          window.open(resultado.data, "_blank");
          this.hideLoading();
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }
    },

    removerDiretorioHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        removerDiretorio(diretorio);
      });
    },
    removerDiretorio() {
      let payload = {
        id: diretorio.id,
        tipoFormularios: diretorio.tipoFormularios,
        idObjeto: this.venda.id
      };

      this.showLoading();
      this.removerDiretorioVenda(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERROR":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },
    recuperarClienteVenda(cliente) {
      let payload = { id: cliente.id };

      this.showLoading();
      this.recuperarCliente(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/clientes");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Oops, this is a error message.");
          this.hideLoading();
        });
    },

    //COMISSÕES
    gerarReciboComissao() {
      let recibosPagosArray = new Array();
      this.comissaoSelecionada.pagamentosComissao.forEach(element => {
        if(element.status === "PAGO") {
          recibosPagosArray.push(element.id);
        }
      });

      if(recibosPagosArray.length == 0) {
        this.$message.warning("Não há recibo pago associado a esta comissão!");
        return;
      }

      let payload = recibosPagosArray;

      this.showLoading();
      this.gerarReciboComissaoPagos(payload)
      .then(resultado => {
        this.hideLoading();

        let blob = new Blob([resultado.data]);
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "RecibosComissao.zip");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },
    gerarListaComissoesCorretores() {
      let payload = {
        nome: "COMISSOES_VENDA",
        venda: {
          id: this.venda.id
        }
      };

      this.showLoading();
      this.gerarRelatorio(payload)
      .then(resultado => {
        this.hideLoading();
        if (resultado.status == "SUCESSO") {
          window.open(resultado.mensagem, "_blank");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    gerarReciboComissaoCorretor() {
      let payload = {
        venda: {
          id: this.venda.id
        },
        corretor: {
          id: this.historicoComissaoSelecionada.corretor.id,
          nome: this.historicoComissaoSelecionada.corretor.nome
        },
        valor: this.historicoComissaoSelecionada.valorPago,
        dataPagamento: this.historicoComissaoSelecionada.dataPagamento
      };

      this.showLoading();
      this.gerarReciboComissaoUnico(payload)
      .then(resultado => {
        this.hideLoading();
        window.open(resultado.data, "_blank");
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },
    cancelarHistoricoPagamentoComissaoHandler() {
      this.$confirm("Deseja cancelar o pagamento selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.cancelarHistoricoPagamentoComissao();
      });
    },
    cancelarHistoricoPagamentoComissao() {
      let payload = {
        id: this.historicoComissaoSelecionada.id
      };

      this.showLoading();
      this.cancelarPagamentoComissao(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro.");
        });
    },
    removerHistoricoPagamentoComissaoHandler(scope) {
      this.$confirm("Deseja remover o pagamento selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerHistoricoPagamentoComissao(scope);
      });
    },
    removerHistoricoPagamentoComissao(scope) {
      let payload = {
        id: this.historicoComissaoSelecionada.id,
        venda: { id: this.venda.id }
      };

      this.showLoading();
      this.removerPagamentoComissao(payload)
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.deleteRow(
              scope.$index,
              this.comissaoSelecionada.pagamentosComissao
            );
            break;
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },
    configurarDataGridComissoes() {
      let comissoesCorretor = new Array();

      if(this.permissoes.visualizacaoSomenteComissoesCorretor && this.venda.cliente.id !== 0 && this.venda.status === "APROVADO") {
        this.venda.comissoes.forEach(comissao => {
          if(comissao.corretor !== null && comissao.corretor.id === this.usuarioLogado.id) {
            comissoesCorretor.push(comissao);
          }
        });
        this.venda.comissoes = comissoesCorretor;
      }
    },

    //ARQUIVOS
    removerArquivoHandler(arquivo) {
      let payload = { id: arquivo.id };

      this.showLoading();
      this.removerArquivo(payload)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERROR":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },

    //OBSERVACOES
    exibirObservacao(observacaoSelecionada) {
      this.observacaoSelecionada = observacaoSelecionada;
    },

    removerObservacaoHandler(observacao) {
      let payload = { id: observacao.id };

      this.showLoading();
      this.removerObservacao(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.observacaoSelecionada = {};
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    //DIALOGS
    exibirDialogAdicionarComissao(tipo) {
      if(tipo === "IMOBILIARIA") {
        this.comissaoImobiliaria = true;
      } else {
        this.comissaoImobiliaria = false;
      }

      this.visibilidadeDialogAdicionarComissao = true;
    },
    fecharDialogAdicionarComissao() {
      this.restanteComissoes();
      this.visibilidadeDialogAdicionarComissao = false;
    },
    exibirDialogPagarComissao() {
      this.visibilidadeDialogPagarComissao = true;
    },
    fecharDialogPagarComissao() {
      this.visibilidadeDialogPagarComissao = false;
    },
    exibirDialogPagarComissaoCompleta() {
      this.visibilidadeDialogPagarComissaoCompleta = true;
    },
    fecharDialogPagarComissaoCompleta() {
      this.visibilidadeDialogPagarComissaoCompleta = false;
    },
    exibirDialogAdicionarPagamentoComissao() {
      this.visibilidadeDialogAdicionarPagamentoComissao = true;
    },
    fecharDialogAdicionarPagamentoComissao() {
      this.visibilidadeDialogAdicionarPagamentoComissao = false;
    },
    exibirDialogRemoverComissao() {
      this.visibilidadeDialogRemoverPagamentoComissao = true;
    },
    fecharDialogRemoverComissao() {
      this.restanteComissoes();
      this.visibilidadeDialogRemoverPagamentoComissao = false;
    },
    exibirDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = true;
    },
    fecharDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = false;
    },
    exibirDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = true;
    },
    fecharDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = false;
    },
    exibirDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = true;
    },
    fecharDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = false;
    },
    exibirDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = true;
    },
    fecharDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = false;
    },
    exibirGravarObservacaoDialog() {
      this.visibilidadeGravarObservacaoDialog = true;
    },
    fecharGravarObservacaoDialog() {
      this.visibilidadeGravarObservacaoDialog = false;
    },

    //UTIL
    enderecoCompleto(imovel) {
      let texto =
        "(" +
        imovel.idNaImobiliaria +
        ") " +
        (imovel.tipoImovel !== undefined
          ? imovel.tipoImovel.nome + " - "
          : "") +
        imovel.endereco;

      let numeroEndereco = imovel.numeroEndereco;
      if (numeroEndereco.length > 0) {
        texto += ", " + numeroEndereco;
      }

      let bairro = imovel.bairro.nome;
      if (bairro.length > 0) {
        texto += " (" + bairro + ")";
      }

      return texto;
    },
    formatarValor(valor) {
      return Util.formatarValor(valor);
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    filtrarUsuariosSelect(queryString) {
      let payload = { nome: queryString };
      
      this.loadingUsuarios = true;
      this.listarUsuarios(payload)
      .then(() => {
        this.loadingUsuarios = false;    
      }).catch(() => {
        this.loadingUsuarios = false;    
      });
    },
    filtrarClientesSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingClientes = true;
      this.listarClientes(payload)
      .then(() => {
        this.loadingClientes = false;
      }).catch(() => {
        this.loadingUsuarios = false;    
      });
    },
    filtrarImoveisSelect(queryString) {
      let payload = {
        endereco: queryString,
        operacao: "VENDA",
        status: "DISPONIVEL"
      };

      this.loadingImoveis = true;
      this.listarImoveis(payload)
      .then(() => {
        this.loadingImoveis = false;
      }).catch(() => {
        this.loadingImoveis = false;
      });
    },
    formatarLabelPagamento(comissao) {
      return this.util.getLabel(this.statusPagamento, comissao.status);
    },
    formatarLabelCorretor(comissao) {
      return comissao.corretor === null ||
        comissao.corretor === undefined ||
        comissao.corretor.nome === null ||
        comissao.corretor.nome === undefined
        ? "IMOBILIÁRIA"
        : comissao.corretor.nome;
    },
    tabClicked(tab) {
      if(tab.name === "logs") {
        let payload = { venda: { id: this.venda.id } };
        this.recuperarLogs(payload);
      }

      if (tab.name === "formularios") {
        let payload = { tipo: "VENDA" };
        this.recuperarFormularios(payload);
      }
    },
    exibirHistoricoPagamento(comissaoSelecionada) {
      this.comissaoSelecionada = comissaoSelecionada;
      this.historicoComissaoSelecionada = {
        corretor: {
          nome: ""
        }
      };
    },
    selecionarHistoricoComissao(historicoComissaoSelecionada) {
      this.historicoComissaoSelecionada = historicoComissaoSelecionada;
    },
    calcularValorComissao() {
      let totalVenda = this.venda.valor;
      this.venda.valorComissao = new BigDecimal(totalVenda)
        .multiply(new BigDecimal(this.venda.comissao))
        .divide(new BigDecimal(100))
        .round(2, BigDecimal.RoundingModes.HALF_UP)
        .getValue();

      this.restanteComissoes();
    },
    calcularComissao() {
      let valorVenda = this.venda.valor;
      this.venda.comissao = new BigDecimal(this.venda.valorComissao)
        .multiply(new BigDecimal(100))
        .round(10, BigDecimal.RoundingModes.HALF_UP)
        .divide(new BigDecimal(valorVenda))
        .round(10, BigDecimal.RoundingModes.HALF_UP)
        .round(2, BigDecimal.RoundingModes.HALF_UP)
        .getValue();

      this.restanteComissoes();
    },
    restanteComissoes() {
      var valorComissao = new BigDecimal(this.venda.valorComissao);
      if (valorComissao.compareTo(new BigDecimal(0)) > 0) {
        this.percentualRestante = valorComissao
          .subtract(
            new BigDecimal(this.somarComissoes()).round(
              10,
              BigDecimal.RoundingModes.HALF_UP
            )
          )
          .divide(valorComissao.round(10, BigDecimal.RoundingModes.HALF_UP))
          .multiply(new BigDecimal(100))
          .round(2, BigDecimal.RoundingModes.HALF_UP)
          .getValue();
      }

      this.comissaoRestante = valorComissao
        .subtract(new BigDecimal(this.somarComissoes()))
        .round(2, BigDecimal.RoundingModes.HALF_UP)
        .getValue();
    },
    somarComissoes() {
      let somatorio = new BigDecimal(0);
      this.venda.comissoes.forEach(comissao => {
        somatorio = somatorio.add(new BigDecimal(comissao.valor));
      });

      return somatorio.getValue();
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    limpar() {
      this.$refs["formVenda"].resetFields();
    },
    enviar(){
      if(this.dadosPesquisaVenda){
        this.pesquisar();
      }
    }
  }
};